<template>
  <div>
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
    </div>

    <div class="note-container" style="font-family: 'Poppins', sans-serif; overflow-y: auto;">
      <div class="create-order" style="min-width: 1200px;">
        <div class="left">
          <h3 class="order-type">Orden de Trabajo: {{ tempOrderNumber }}</h3>
        </div>
        <div class="right">
          <button type="button" @click="backMaintenance">Volver</button>
        </div>
      </div>

      <div class="main-data-container" style="min-width: 1200px;">
        <div class="container-card maintenance-general">
          <div class="title maintenance-title-row">
            <h4>Información General</h4>
            <span class="folio-badge">Folio: {{ tempOrderNumber }}</span>
          </div>
          <div class="container-card-body">
            <div class="maintenance-general-grid">
              <div class="maintenance-column">
                <div class="form-input-group">
                  <label>Unidad:</label>
                  <select v-model="unit" :class="{ invalid: validationErrors.unit }">
                    <option value="">Seleccione</option>
                    <option v-for="u in units" :key="u.unit_id" :value="u.id">
                      {{ u.unit_short_id }} - {{ u.unit_plates }}
                    </option>
                  </select>
                </div>

                <div class="form-input-group">
                  <label>Sucursal:</label>
                  <select v-model="sucursal">
                    <option value="">Seleccione</option>
                    <option v-for="branch in sucursales" :key="branch" :value="branch">
                      {{ branch }}
                    </option>
                  </select>
                </div>

                <div class="form-input-group">
                  <label>KM Recorridos:</label>
                  <input type="number" min="0" v-model.number="odometer_reading" />
                </div>

                <div class="form-input-group">
                  <label>Vo. Bueno:</label>
                  <select v-model="approved_by">
                    <option value="">Seleccione</option>
                    <option v-for="emp in employees" :key="emp.id" :value="emp.id">
                      {{ emp.employee_ident }} - {{ emp.employee_first_name }} {{ emp.employee_last_name }}
                    </option>
                  </select>
                </div>

                <div class="form-input-group">
                  <label>Operador:</label>
                  <select v-model="operator">
                    <option value="">Seleccione</option>
                    <option v-for="emp in operatorEmployees" :key="emp.id" :value="emp.id">
                      {{ emp.employee_ident }} - {{ emp.employee_first_name }} {{ emp.employee_last_name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="maintenance-column">
                <div class="form-input-group">
                  <label>Motivo:</label>
                  <select v-model="motive_of_service" :class="{ invalid: validationErrors.motive_of_service }">
                    <option value="">Seleccione</option>
                    <option v-for="cause in motives" :key="cause" :value="cause">{{ cause }}</option>
                  </select>
                </div>

                <div class="form-input-group">
                  <label>Causa:</label>
                  <select v-model="cause">
                    <option value="">Seleccione</option>
                    <option v-for="item in causes" :key="item" :value="item">{{ item }}</option>
                  </select>
                </div>

                <div class="form-input-group">
                  <label>Hrs. Trabajadas:</label>
                  <input type="text" :value="worked_hours_display" disabled />
                </div>

                <div class="form-input-group">
                  <label>Severidad:</label>
                  <div class="radio-group">
                    <label><input type="radio" value="Mayor" v-model="repair_type" /> Mayor</label>
                    <label><input type="radio" value="Menor" v-model="repair_type" /> Menor</label>
                  </div>
                </div>

                <div class="form-input-group">
                  <label>Incidencia:</label>
                  <input type="text" v-model="incidence" disabled />
                </div>
              </div>
            </div>

            <div class="form-input-group full-width">
              <label>Falla:</label>
              <textarea v-model="service_description" :class="{ invalid: validationErrors.service_description }"></textarea>
            </div>
          </div>
        </div>

        <div class="maintenance-side">
          <div class="container-card">
            <div class="title">
              <h4>Tiempos</h4>
            </div>
            <div class="container-card-body">
              <div class="form-input-group">
                <label>Solicitud:</label>
                <input type="datetime-local" v-model="request_time_display" disabled />
              </div>
              <div class="form-input-group">
                <label>Programada para:</label>
                <input type="datetime-local" v-model="scheduled_for" :class="{ invalid: validationErrors.scheduled_for }" />
              </div>
              <div class="form-input-group">
                <label>Recepción:</label>
                <input type="datetime-local" v-model="reception_time" />
              </div>
              <div class="form-input-group">
                <label>Inicio:</label>
                <input type="datetime-local" v-model="start_time" />
              </div>
              <div class="form-input-group">
                <label>Salida Aprox.:</label>
                <input type="datetime-local" v-model="estimated_end_time" />
              </div>
              <div class="form-input-group">
                <label>Término:</label>
                <input type="datetime-local" v-model="end_time" />
              </div>
            </div>
          </div>

          <div class="container-card">
            <div class="title">
              <h4>Costos</h4>
            </div>
            <div class="container-card-body">
              <div class="form-input-group">
                <label>Refacciones:</label>
                <input type="number" min="0" v-model.number="parts_cost" />
              </div>
              <div class="form-input-group">
                <label>Mano de Obra:</label>
                <input type="number" min="0" v-model.number="labor_cost" />
              </div>
              <div class="form-input-group">
                <label>Total:</label>
                <input type="number" :value="total_cost" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-actions" style="min-width: 1200px;">
        <button
          v-if="canCreateOrder"
          type="button"
          class="btn-submit-save"
          @click="saveOrder"
          :disabled="savingOrder"
        >
          {{ savingOrder ? 'Guardando...' : 'Guardar' }}
        </button>
        <button type="button" class="btn-submit-cancel" @click="backMaintenance">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'NewMaintenanceOrder',
  data() {
    return {
      permissions: [],
      tempOrderNumber: 0,
      request_time_display: '',
      scheduled_for: '',
      unit: '',
      sucursal: '',
      odometer_reading: '',
      approved_by: '',
      operator: '',
      service_description: '',
      motive_of_service: '',
      cause: '',
      incidence: '',
      repair_type: 'Mayor',
      reception_time: '',
      start_time: '',
      estimated_end_time: '',
      end_time: '',
      parts_cost: '',
      labor_cost: '',
      employeeid: '',
      units: [],
      employees: [],
      operatorEmployees: [],
      motives: ['Correctivo', 'Preventivo'],
      causes: ['Negligencia', 'Desgaste', 'Colisión o Accidente', 'Mantenimiento', 'Otro (Especificar)'],
      sucursales: ['LINCOLN'],
      savingOrder: false,
      validationErrors: {
        unit: false,
        service_description: false,
        motive_of_service: false,
        scheduled_for: false,
      },
    }
  },
  computed: {
    canCreateOrder() {
      return this.hasAnyPerm(['maintenance.create_order', 'ui_access_maintenance_workshop_card'])
    },
    total_cost() {
      const parts = Number(this.parts_cost) || 0
      const labor = Number(this.labor_cost) || 0
      return (parts + labor).toFixed(2)
    },
    worked_hours_display() {
      if (!this.start_time || !this.end_time) return 'FALTA INFORMACION'
      const start = new Date(this.start_time)
      const end = new Date(this.end_time)
      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 'FALTA INFORMACION'
      const diffMs = end.getTime() - start.getTime()
      if (diffMs < 0) return 'FALTA INFORMACION'
      const totalMinutes = Math.floor(diffMs / 60000)
      const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0')
      const minutes = String(totalMinutes % 60).padStart(2, '0')
      return `${hours}:${minutes}`
    },
  },
  mounted() {
    this.loadPermissions()
    if (!this.canCreateOrder) {
      this.$router.push({ name: 'MainPanel' })
      return
    }
    this.request_time_display = this.toDatetimeLocal(new Date())
    this.fetchCurrentUser()
    this.fetchUnits()
    this.fetchEmployees()
    this.fetchOperatorEmployees()
    this.getTempOrderNumber()
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
      } catch (error) {
        this.permissions = []
      }
    },
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    hasAnyPerm(perms) {
      if (!Array.isArray(perms) || perms.length === 0) return false
      return perms.some((perm) => this.hasPerm(perm))
    },
    backMainPanel() {
      this.$router.push('/main-panel')
    },
    backMaintenance() {
      this.$router.push('/modulo-mantenimiento')
    },
    toDatetimeLocal(date) {
      const pad = (n) => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
    },
    async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: `Token ${localStorage.getItem('authToken')}` },
        })
        this.employeeid = response.data.employee_id
      } catch (error) {
        console.error('There was an error fetching the user data:', error)
      }
    },
    async fetchUnits() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/units-for-forms`)
        this.units = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching units:', error)
      }
    },
    async fetchEmployees() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/approvers-for-forms`)
        this.employees = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching approvers:', error)
      }
    },
    async fetchOperatorEmployees() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/operators-for-forms`)
        this.operatorEmployees = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching operator employees:', error)
      }
    },
    async getTempOrderNumber() {
      const apiDirectory = process.env.API_DIRECTORY
      const response = await axios.post(`${apiDirectory}/calculate-maintenance-order-number`)
      this.tempOrderNumber = response.data
    },
    validateForm() {
      this.validationErrors.unit = !this.unit
      this.validationErrors.service_description = !this.service_description
      this.validationErrors.motive_of_service = !this.motive_of_service
      this.validationErrors.scheduled_for = !this.scheduled_for
      return !this.validationErrors.unit &&
        !this.validationErrors.service_description &&
        !this.validationErrors.motive_of_service &&
        !this.validationErrors.scheduled_for
    },
    async saveOrder() {
      if (!this.canCreateOrder) {
        Swal.fire('Sin acceso', 'No tienes permisos para crear órdenes.', 'warning')
        return
      }
      if (!this.validateForm()) {
        await Swal.fire('Faltan datos', 'Completa los campos obligatorios.', 'warning')
        return
      }

      try {
        this.savingOrder = true
        const apiDirectory = process.env.API_DIRECTORY

        const numberResponse = await axios.post(`${apiDirectory}/calculate-maintenance-order-number`)
        const orderNumber = numberResponse.data

        const payload = {
          order_number: orderNumber,
          unit: this.unit,
          data_entry_clerk: this.employeeid,
          signed_off_by: this.approved_by || null,
          request_time: new Date().toISOString(),
          scheduled_for: this.scheduled_for || null,
          reception_time: this.reception_time || null,
          start_time: this.start_time || null,
          estimated_end_time: this.estimated_end_time || null,
          end_time: this.end_time || null,
          sucursal: this.sucursal || null,
          odometer_reading: this.odometer_reading || null,
          operator: this.operator || null,
          service_description: this.service_description,
          motive_of_service: this.motive_of_service,
          cause: this.cause || null,
          repair_severity: this.repair_type || null,
          status: 1,
          parts_cost: this.parts_cost || null,
          labor_cost: this.labor_cost || null,
          total_cost: this.total_cost,
        }

        const response = await axios.post(`${apiDirectory}/create-maintenance-order`, payload, {
          headers: { 'Content-Type': 'application/json' },
        })

        if (this.tempOrderNumber !== orderNumber) {
          await Swal.fire({
            title: 'Atención',
            html: `El número <b>${this.tempOrderNumber}</b> ya fue ocupado.<br>La orden se guardó con el número: <b>${orderNumber}</b>`,
            icon: 'warning',
            confirmButtonText: 'Aceptar',
          })
        } else {
          await Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            background: '#d4edda',
            title: '¡Guardado!',
            text: 'Los datos del formulario se han guardado con éxito.',
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
          })
        }

        this.$router.push({ name: 'UnitMaintenance' })
        return response
      } catch (error) {
        console.error(error)
        Swal.fire('Error', 'Hubo un problema al guardar la orden.', 'error')
      } finally {
        this.savingOrder = false
      }
    },
  },
}
</script>

<style scoped>
.logo-button {
  height: 40px;
}

.nav-bar-operations {
  height: 50px;
}

.note-container {
  padding: 0 15px;
}

.create-order {
  display: flex;
  padding: 5px 0;
  justify-content: space-between;
}

.create-order h3 {
  font-size: 18px;
  font-weight: bold;
  padding-right: 10px;
}

.create-order .left {
  display: flex;
  align-items: center;
}

.create-order .right {
  display: flex;
  gap: 7px;
}

.create-order button {
  padding: 5px 15px;
  background-color: #d5171d;
  color: white;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: .3s all;
}

.create-order button:hover {
  background: black;
}

.main-data-container {
  display: grid;
  grid-template-columns: repeat(14, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.container-card {
  border: 1px solid #f3f3f3;
  border-radius: 0px;
  margin-bottom: 0px;
  border-top: none;
}

.container-card-body {
  padding: 5px 8px;
}

.title {
  background: #f2f7fa;
  padding: 5px 15px;
  border-radius: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.title h4 {
  font-size: 16px;
  text-align: left;
  line-height: 20px;
  margin-bottom: 0;
  font-weight: 700;
}

.maintenance-title-row {
  justify-content: space-between;
}

.folio-badge {
  font-size: 12px;
  color: #6b6b6b;
  font-weight: 600;
}

.maintenance-general {
  grid-column: span 10;
}

.maintenance-side {
  grid-column: span 4;
  display: grid;
  gap: 12px;
}

.maintenance-general-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 16px;
}

.maintenance-column {
  display: grid;
  gap: 8px;
}

.form-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-input-group label {
  min-width: 110px;
  margin: 0;
}

.form-input-group.full-width {
  margin-top: 8px;
}

input[type=text],
input[type=number],
input[type=datetime-local],
select,
textarea {
  padding: 1.5px 8px;
  width: 100%;
  font-size: 11px;
  border: 1px solid #ececec;
  border-radius: 5px;
  font-weight: 500;
  outline: none;
  margin-bottom: 0;
}

.form-input-group input,
.form-input-group select,
.form-input-group textarea {
  flex: 1;
}

input[type=text]:focus,
input[type=number]:focus,
input[type=datetime-local]:focus,
select:focus,
textarea:focus {
  border: 1px solid #ffc736;
}

label {
  display: block;
  font-size: 11px;
  margin-bottom: 0;
  font-weight: 600;
  color: #929292;
}

.form-input-group label {
  margin-top: 2px;
}

textarea {
  min-height: 64px;
  resize: vertical;
}

.invalid {
  border-color: #d9534f !important;
  background: #fff3f3;
}

.radio-group {
  display: flex;
  gap: 12px;
  font-size: 11px;
  color: #6b6b6b;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 12px 0 16px;
}

.btn-submit-save {
  background-color: #2ada85;
  color: #fff;
  border: none;
  padding: 4px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}

.btn-submit-cancel {
  background-color: #d5171d;
  color: #fff;
  border: none;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
}
</style>
